import BulkOrder from "../pages/order/BulkOrder";

const orderRoutes = [
  {
    path: "/bulk-order",
    element: <BulkOrder />,
  },
];

export default orderRoutes;